__turbopack_context__.v({
  "form": "ResendCode-module-scss-module__r7PEnq__form",
  "progressContainer": "ResendCode-module-scss-module__r7PEnq__progressContainer",
  "resendCode": "ResendCode-module-scss-module__r7PEnq__resendCode",
  "resendCodeButton": "ResendCode-module-scss-module__r7PEnq__resendCodeButton",
  "resendCodeText": "ResendCode-module-scss-module__r7PEnq__resendCodeText",
  "verificationCodeError": "ResendCode-module-scss-module__r7PEnq__verificationCodeError",
  "verificationTokenFormContainer": "ResendCode-module-scss-module__r7PEnq__verificationTokenFormContainer",
  "verificationTokenFormContainerError": "ResendCode-module-scss-module__r7PEnq__verificationTokenFormContainerError",
});
